import axios, { AxiosRequestConfig } from 'axios'
import { trimStart, trimEnd } from 'lodash-es'
import { getUserToken } from 'web-queries/src/utils/user'

const NEXT_PUBLIC_REST_API_ENDPOINT = trimEnd(process.env.NEXT_PUBLIC_REST_API_ENDPOINT, '/')

export const findMyInfo = async () => {
  const res = await axios.get(`${NEXT_PUBLIC_REST_API_ENDPOINT}/users/me`, {
    headers: {
      Authorization: `Bearer ${getUserToken()}`,
    },
  })
  return res.data
}

export const request = async (url: string) => {
  const res = await axios.get(`${NEXT_PUBLIC_REST_API_ENDPOINT}/${trimStart(url, '/')}`, {
    headers: {
      Authorization: `Bearer ${getUserToken()}`,
    },
  })
  return res.data
}

export const post = async (params: AxiosRequestConfig) => {
  const res = await axios({
    ...params,
    url: `${NEXT_PUBLIC_REST_API_ENDPOINT}/${trimStart(params.url, '/')}`,
    method: params.method ?? 'POST',
    headers: {
      Authorization: `Bearer ${getUserToken()}`,
    },
  })

  return res.data
}

export const uploadImages = async (files: FileList | Blob) => {
  const formData = new FormData()

  if (Array.isArray(files)) {
    Array.from(files).forEach(file => {
      formData.append('files', file)
    })
  } else {
    formData.append('files', files as Blob, `${new Date().toString()}.jpg`)
  }

  const res = await axios.post(`${NEXT_PUBLIC_REST_API_ENDPOINT}/upload`, formData, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${getUserToken()}`,
    },
  })

  return res.data[0]
}

export const uploadImageByUrl = async (imageUrl: string) => {
  try {
    const res = await fetch(`/api/image-proxy?imageUrl=${encodeURIComponent(imageUrl)}`)
    return await uploadImages(await res.blob())
  } catch (e) {
    console.log(e)
  }
}

export const requestResetPassword = async (email: string) => {
  const res = await axios.post(`${NEXT_PUBLIC_REST_API_ENDPOINT}/auth/forgot-password`, {
    email,
    url: 'https://indistreet.com/reset-password',
  })
  return res.data
}

export const changePassword = async (code: string, password: string, passwordConfirmation: string) => {
  try {
    const res = await axios.post(`${NEXT_PUBLIC_REST_API_ENDPOINT}/auth/reset-password`, {
      code,
      password,
      passwordConfirmation,
    })

    return res.data
  } catch (e) {
    const error = {
      statusCode: e.response?.data?.statusCode ?? 500,
    }

    throw error
  }
}

export const isUniqueMusicianSlug = async (slug: string) => {
  try {
    await axios.get(`${NEXT_PUBLIC_REST_API_ENDPOINT}/musicians-by-slug/${slug}`)
    return false
  } catch (e) {
    if (e.message.includes('404')) {
      return true
    }
  }
}

export const isUniqueStageSlug = async (slug: string) => {
  try {
    await axios.get(`${NEXT_PUBLIC_REST_API_ENDPOINT}/stages-by-slug/${slug}`)
    return false
  } catch (e) {
    if (e.message.includes('404')) {
      return true
    }
  }
}
